import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aerqrduuww: FaireBrandEntity = {
  token: "b_aerqrduuww",
  type: "brand",
  name: "MoodGold",
  avatarUrl:
    "https://cdn.faire.com/fastly/b69b55196c8fedcbfbbe4794b7e0fbcc2cfd60ea1ab917c17fd61db06e4c779f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1d385ca89febc59d62a6500175ae2ac82721c882bc33184575a52dbdec1d8eb3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b69b55196c8fedcbfbbe4794b7e0fbcc2cfd60ea1ab917c17fd61db06e4c779f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1d385ca89febc59d62a6500175ae2ac82721c882bc33184575a52dbdec1d8eb3.jpeg",
  location: "KILLEEN, TX, USA",
  minimumOrderDollars: 130,
  rating: 4.6,
  reviewCount: 16,
  isInsider: false,
  description:
    "Our rings are made from genuine 925 sterling silver, ensuring both quality and authenticity. Unlike many others, our rings won’t leave your fingers with any unwanted green stains—just the true beauty of our color-changing magic.\n\nAt MoodGold, we believe your ring should be as unique as you are. Welcome to the home of mood rings.\n\nLet me know if you need any adjustments!",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:48.171Z",
    importedBy: "entity-db-cli",
  },
};
